module.exports = __webpack_public_path__ + "resources/img/@tmp_captcha.6e1ce923907b6c05147897bd81ebbfec.png";